export default {
    title: 'Competency translations',
    autoTranslate: 'Translate automatically',
    fieldsTranslated: '{{translated}}/{{total}} fields translated',
    profilesSection: 'Competency profiles',
    performanceScoreLevelsSection: 'Performance score levels',
    saveSuccess: 'Translations saved successfully.',
    comingSoonTooltip: 'This feature will be available soon.',
    saveWithCount: 'Save ({{count}})',
    translationPlaceholder: 'Translation…',
    emptySource: '(empty)',
    maxLengthExceeded: 'This field cannot exceed {{max}} characters.',
};
